import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-careers',
    imports: [],
    templateUrl: './careers.component.html',
    styleUrls: ['./careers.component.css']
})
export class CareersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}